module.exports = __webpack_public_path__ + "images/accents/accent-people-training@1x-e7a58073b849b61eca79695435627ef2.webp";